import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import ConnectWalletButton from './connectWallet';
import styled, { createGlobalStyle } from 'styled-components';
import user from 'stores/user';
import { observer } from 'mobx-react';
import { TYPE } from 'theme';
import { Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NETWORK_CONFIG } from 'constant';
import { dashboardPath, homePath, invitePath, rankingPath, luckyDrawPath } from 'constant/route-path';
import { Logo } from 'common-helpers/img';
import { darken } from 'polished';

const HeaderWapper = styled.div`
    position: fixed;
    z-index: 88;
    left: 0;
    top: 0;
    width: 100%;
    height: 100px;
    background-color: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    font-size: 20px;

    &.showBg {
        background: #121212;
        transition: background-color 0.2s linear;
    }

    .logoContainer {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        cursor: pointer;
        width: 165px;
    }
    .content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        width: 100%;
        max-width: 1200px;
        height: 72px;
        border-radius: 16px;
        box-sizing: border-box;
        padding: 0 20px;
        ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 0 10px;
        `}
    }

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;

        .content {
            width: 100%;

            .menu-icon {
                display: block;
                position: relative;
                width: 24px;
                height: 24px;
                font-size: 0;
                z-index: 2;

                &::before,
                &::after {
                    display: block;
                    position: absolute;
                    left: 2px;
                    content: '';
                    width: 20px;
                    height: 2px;
                    background: $pink;
                    transition: 0.3s;
                    cursor: pointer;
                }

                &::before {
                    top: 6.5px;
                }

                &::after {
                    top: 14.5px;
                }
            }            
        }

        &.open {
            .menu-icon {
                &::before,
                &::after {
                    top: 10px;
                }

                &::before {
                    transform: rotate(45deg);
                }

                &::after {
                    transform: rotate(-45deg);
                }
            }

            .right {
                display: flex;
                opacity: 1;
                z-index: 1;
            }
        }
    `}
`;

const MobileWrapper = styled.div`
    display: none;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        position: fixed;
        z-index: 10;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: ${theme.c.bg01};
        box-sizing: border-box;
        padding: 8px;
  `}
`;

const NavWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 60px;
    flex-direction: row;
    margin-right: 64px;

    ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 200px;
    flex-direction: column;
    padding: 20px 0;
    `};

    a {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #fff;
        position: relative;
        text-decoration: none;
        cursor: pointer;
        transition: transform 0.3s linear;
        position: relative;
        &.active > div {
            color: ${({ theme }) => theme.c.primary01} !important;
        }
        &:hover > div {
            color: ${({ theme }) => darken(0.2, theme.c.primary01)} !important;
        }

        .comingSoon {
            width: 72px;
            height: 12px;
            font-size: 8px;
            background: #fad218;
            border-radius: 10px;
            position: absolute;
            top: 0;
            left: 50%;
            padding: 0 8px;
            color: #000;
            transform: translate(0, -100%);
        }
    }
`;
const Nav = styled(NavLink)`
    position: relative;
    &.disabled {
        pointer-events: none;
    }
`;

const NetworkLabel = styled.div`
    padding: 2px 4px;
    background: ${({ theme }) => theme.c.linearGradientBg};
    color: #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
`;

const Menu = styled.div`
    display: none;
    ${({ theme }) => theme.mediaWidth.upToMedium`
    display: block;
    `};

    svg {
        color: #fff;
    }
`;

const StyledDrawer = styled(Drawer)``;

const GlobalStyle = createGlobalStyle`
    .MuiDrawer-paper{
        background: #000;
        padding-top: 40px;
    }
`;

const PCNavWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${({ theme }) => theme.mediaWidth.upToMedium`
     display: none;
    `};
    /* padding: 0 40px; */
`;

const StyledConnectWalletButton = styled(ConnectWalletButton)`
    height: 50px !important;
    padding: 0 20px !important;
    border-radius: 25px !important;
    min-width: unset !important ;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        height: 40px !important;
    `};
`;

interface Props {
    showConnectButton?: boolean;
    connected?: boolean;
    onClickConnect?(): void;
    onClickDisconnect?(): void;
    address?: string;
    showLanguage?: boolean;
    notSupportedChain?: boolean;
}

function Header(props: Props) {
    const {
        // connected,
        // onClickConnect,
        showLanguage,
        // notSupportedChain,
    } = props;
    const [headerBgShow, setHeaderBgShow] = useState(false);
    const { connected, address: walletAddress } = user;
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const isInvitePage = location.pathname === invitePath;

    useEffect(() => {
        const dom: Element | null = document.querySelector('.container');
        const scroll = () => {
            if (dom) {
                if (dom.scrollTop >= 20) {
                    setHeaderBgShow(true);
                } else {
                    setHeaderBgShow(false);
                }
            }
        };
        if (dom) {
            dom.addEventListener('scroll', scroll);
        }

        return () => {
            if (dom) {
                dom.removeEventListener('scroll', scroll);
            }
        };
    }, []);

    const Navs = ({ onChange }: { onChange?: () => void }) => {
        const location = useLocation();
        return (
            <NavWrapper className="navs">
                <GlobalStyle />
                <Nav id="home" to={{ pathname: homePath, search: location.search }} onClick={onChange}>
                    <TYPE.main fontWeight={700}>Home</TYPE.main>
                </Nav>
                <Nav id="lucky-draw" to={{ pathname: luckyDrawPath, search: location.search }} onClick={onChange}>
                    <TYPE.main fontWeight={700}>Lucky Draw</TYPE.main>
                </Nav>
                <Nav id="ranking" to={{ pathname: rankingPath, search: location.search }} onClick={onChange}>
                    <TYPE.main fontWeight={700}>Ranking</TYPE.main>
                </Nav>
                <Nav id="dashboard" to={{ pathname: dashboardPath, search: location.search }} onClick={onChange}>
                    <TYPE.main fontWeight={700}>Dashboard</TYPE.main>
                </Nav>
            </NavWrapper>
        );
    };
    return (
        <>
            <HeaderWapper className={classNames('header', isOpen && 'open', headerBgShow && 'showBg')}>
                <div className="content">
                    <div className="logoContainer">
                        <Logo
                            onClick={() => {
                                window.open('https://www.goat.network/', '_blank');
                            }}
                        />
                    </div>
                    <PCNavWrapper>
                        {!isInvitePage && <Navs />}
                        <StyledConnectWalletButton connected={connected} walletAddress={walletAddress || ''} />
                    </PCNavWrapper>
                    {!isInvitePage && (
                        <Menu
                            onClick={() => {
                                setIsOpen(true);
                            }}
                        >
                            <MenuIcon />
                        </Menu>
                    )}
                </div>
            </HeaderWapper>

            <MobileWrapper>
                <StyledConnectWalletButton connected={connected} walletAddress={walletAddress || ''} />
                <StyledDrawer
                    anchor="right"
                    open={isOpen}
                    onClose={() => {
                        setIsOpen(false);
                    }}
                >
                    <Navs onChange={() => setIsOpen(false)} />
                </StyledDrawer>
                <NetworkLabel style={{ marginRight: '10px' }}>
                    <TYPE.main fontSize={12} fontWeight={600}>
                        {NETWORK_CONFIG[user.chainId].name}
                    </TYPE.main>
                </NetworkLabel>

                {/* <ThemeButton onClick={user.toggleTheme}>
                    <ThemeImg />
                </ThemeButton> */}
            </MobileWrapper>
        </>
    );
}

export default observer(Header);
